import { formatNumberMix } from '@/utils'
export default {
  data() { },
  methods: {
    setRefundReasonConfigs(data = []) {
      return {
        type: 'ring',
        title: this.$t('sale-order::refundReason_title'),
        ref: 'ringChartSale',
        height: '325px',
        tip: '',
        chart: {
          tooltip: {
            trigger: 'item',
            formatter: (params, ticket, callback) => {
              return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color}"></span><span>${params.name}  </span><span style="font-weight:900;">${params.value}</span><br/>
                          <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;"></span><span>${params.name}  </span><span style="font-weight:900;">${params.data.rate}%</span>`
            }
          },
          series: [
            {
              type: 'pie',
              radius: '50%',
              label: {
                show: false
              },
              itemStyle: {
                normal: {
                  labelLine: {
                    show: false
                  }
                }
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '12'
                }
              },
              labelLine: {
                show: false
              },
              data: [
                ...data.map(item => {
                  return {
                    value: item.refundAmount,
                    rate: item.refundPercentage,
                    name: item.refundReason
                  }
                })
              ]
            }
          ]
        }
      }
    },
    setRefundTimeConfigs(data = [], money = 0, currency = 'USD') {
      return {
        type: 'ring',
        ref: 'ringChartSale',
        height: '308px',
        title: this.$t('sale-order::intervalTime_title'),
        tip: this.$t('sale-order::intervalTime_tip', { money: money || 0, currency: 'USD' }),
        chart: {
          tooltip: {
            trigger: 'item',
            formatter: (params, ticket, callback) => {
              return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color}"></span><span>${params.name}  </span><span style="font-weight:900;">${params.value}</span><br/>
                          <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;"></span><span>${params.name}  </span><span style="font-weight:900;">${params.data.rate}%</span>`
            }
          },
          series: [
            {
              type: 'pie',
              radius: '50%',
              label: {
                show: false
              },

              itemStyle: {
                normal: {
                  labelLine: {
                    show: false
                  }
                }
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '12'
                }
              },
              labelLine: {
                show: false
              },
              data: [
                ...data.map(item => {
                  return {
                    value: item.refundAmount,
                    rate: item.refundAmountRate,
                    name: item.intervalDays
                  }
                })
              ]
            }
          ]
        }
      }
    },
    setShopTableConfig(data = []) {
      return {
        type: 'table',
        title: this.$t('sale-order::refundGoods_title'),
        ref: 'table',
        height: '325px',
        cancelShadow: true,
        tableData: data
      }
    },
    setCountryTableConfig(data = []) {
      return {
        type: 'table',
        title: this.$t('sale-order::refundcountry_title'),
        ref: 'table',
        height: '325px',
        cancelShadow: true,
        tableData: data
      }
    },
    setRefundMoneyData(data = []) {
      return {
        type: 'line',
        title: this.$t('sale-order::refundMoney_title'),
        ref: 'lineChart',
        height: '325px',
        chart: {
          legend: {
            show: true
          },
          xAxis: {
            data: data.map(item => item.refundDate)
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#999999',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#999999'
              }
            },
            {
              type: 'value',
              min: 0,
              splitLine: {
                show: false
              },
              axisLabel: {
                margin: 16,
                color: '#999999',
                formatter: '{value} %'
              }
            }
          ],
          series: [
            {
              name: this.$t('sale-order::line::money'),
              type: 'line',
              data: data.map(item => Number(item.refundAmount))
            }
          ]
        }
      }
    },
    setInitiativeRefundData(data = []) {
      return {
        type: 'line',
        title: this.$t('sale-order::selfRefundMoney_title'),
        ref: 'lineChart',
        height: '325px',
        chart: {
          legend: {
            show: true
          },
          xAxis: {
            data: data.map(item => item.refundDate)
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#999999',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#999999'
              }
            },
            {
              type: 'value',
              min: 0,
              splitLine: {
                show: false
              },
              axisLabel: {
                margin: 16,
                color: '#999999',
                formatter: '{value} %'
              }
            }
          ],
          series: [
            {
              name: this.$t('sale-order::line::money'),
              type: 'line',
              data: data.map(item => Number(item.initiativeRefundAmount))
            }
          ]
        }
      }
    },
    setRefuseCountData(data = []) {
      return {
        type: 'line',
        title: this.$t('sale-order::protestMoney_title'),
        ref: 'lineChart',
        height: '325px',
        chart: {
          legend: {
            show: true
          },
          xAxis: {
            data: data.map(item => item.refundDate)
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: '#999999',
                  type: 'dashed'
                }
              },
              min: 0,
              axisLabel: {
                margin: 16,
                color: '#999999'
              }
            },
            {
              type: 'value',
              min: 0,
              splitLine: {
                show: false
              },
              axisLabel: {
                margin: 16,
                color: '#999999',
                formatter: '{value} %'
              }
            }
          ],
          series: [
            {
              name: this.$t('sale-order::line::money'),
              type: 'line',
              data: data.map(item => Number(item.refuseAmount))
            }
          ]
        }
      }
    },
    setCountList(data) {
      let list = new Array(4).fill(null)
      list[0] = {
        title: this.$t('sale-order::returnGoods_title'),
        tab: 1,
        count: data && this.$dataCheck(formatNumberMix(data.refundCnt, 0, ',')),
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastRefundCnt, 0, ',')),
        statisticsDays: data && data.statisticsDays,
        down: data && data.refundCntRatio ? data.refundCntRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.refundCntRatio, 2, '', '')),
        tooltip: this.$t('sale-order::returnGoods_tooltip')
      }
      list[1] = {
        title: `${this.$t('sale-order::returnMoney_title')}(USD)`,
        // current: data.currency,
        tab: 1,
        count: data && this.$dataCheck(formatNumberMix(data.refundAmount, 2, ',')),
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastRefundAmount, 2, ',')),
        statisticsDays: data && data.statisticsDays,
        down: data && data.refundAmountRatio ? data.refundAmountRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.refundAmountRatio, 2, '', '')),
        tooltip: this.$t('sale-order::returnMoney_tooltip')
      }
      list[2] = {
        title: `${this.$t('sale-order::sales_title')}(USD)`,
        // current: data.currency,
        tab: 1,
        count: data && this.$dataCheck(formatNumberMix(data.saleAmount, 2, ',')),
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastSaleAmount, 2, ',')),
        down: data && data.saleAmountRatio ? data.saleAmountRatio < 0 : false,
        statisticsDays: data && data.statisticsDays,
        rate: data && this.$dataCheck(formatNumberMix(data.saleAmountRatio, 2, '', '')),
        tooltip: this.$t('sale-order::sales_tooltip')
      }
      list[3] = {
        title: this.$t('sale-order::refundRate_title'),
        tab: 1,
        count: data && this.$dataCheck(formatNumberMix(data.refundRate, 2, ',', '%')),
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastRefundRate, 2, ',', '%')),
        statisticsDays: data && data.statisticsDays,
        down: data && data.refundRateRatio ? data.refundRateRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.refundRateRatio, 2, '', '')),
        tooltip: this.$t('sale-order::refundRate_tooltip')
      }
      return list
    }
  }
}
